module.exports = __webpack_public_path__ + "static/media/kredyt_21.d9d1c52d.png";